export enum InfopankLegalStatus {
  Deleted = 'kustutatud',
}
